var diff = function diff(a, b) {
  return a.filter(function (a) {
    return 0 > b.indexOf(a);
  });
};

export default diff;